// extracted by mini-css-extract-plugin
export default {"wrapper":"IndexSidebar-module__wrapper--QL_8x","list":"IndexSidebar-module__list--NvFIa","callToActionWrapper":"IndexSidebar-module__callToActionWrapper--n_3wl"};